/*
  Finder « Trouver ma bobine compatible » : filtres dépendants, tri, état dans l'URL,
  ajout au panier sans rechargement. Vanilla JS, aucune dépendance.

  Données lues sur chaque <li data-tsi-produit> rendu par sections/finder-bobines.liquid :
    data-largeur, data-diametre, data-mandrin, data-longueur  nombres (point décimal)
    data-adhesif                                             texte du métafield type_adhesif
    data-imprimantes                                         noms séparés par « | »
    data-unitaire                                            prix unitaire en centimes
    data-metre                                               prix au mètre en centimes (décimal)
    data-carton                                              prix du carton en centimes
    data-tsi                                                 1 si fabricant mis en avant

  Correspondance imprimante : les noms et la saisie sont normalisés (minuscules, sans
  accents, espaces, tirets, points ni barres). Une bobine correspond si un nom contient
  la saisie, ou si la saisie contient un nom d'au moins 4 caractères. « TM-L100 »,
  « tm l100 » et « Epson TM L100 » trouvent donc la même imprimante.

  Filtres dépendants : le compteur de chaque option est calculé avec tous les AUTRES
  critères actifs ; une option à 0 est désactivée (sauf si elle est sélectionnée).
  Interface : largeur, adhésif et mandrin sont des listes déroulantes (<select
  data-tsi-select>) dans un bandeau au-dessus des résultats ; l'option vide vaut « tous ».

  Tri : le fabricant mis en avant (TSi) passe TOUJOURS devant les autres, quel que soit
  le tri choisi. Ensuite : « recommandé » = prix unitaire croissant ; « unitaire » =
  prix au rouleau croissant ; « metre » = prix au mètre croissant (bobines sans
  métrage en fin) ; « carton » = prix du carton croissant ; « longueur » = métrage
  décroissant. Égalité : ordre de la collection.

  Critère non compatible : quand une imprimante est reconnue, une valeur de critère qui
  n'existe sur aucune de ses bobines compatibles (ex. 80 mm pour une imprimante 58 mm)
  est « non compatible » : champ en orange avec la mention, et dans la liste déroulante
  ces valeurs passent dans un groupe désactivé en fin de liste.

  Suggestion sur l'état vide : on cherche le premier critère actif (largeur, puis mandrin,
  puis adhésif) qui, retiré, redonne des bobines. On affiche pourquoi (imprimante qui
  n'accepte pas la valeur, largeur maximale déduite de ses bobines compatibles) et les
  valeurs possibles de ce critère, la plus fournie d'abord, avec 3 bobines en aperçu.
*/
(function () {
  var racine = document.querySelector('[data-tsi-finder]');
  if (!racine) return;

  var CRITERES = ['largeur', 'adhesif', 'mandrin'];

  function normaliser(texte) {
    return String(texte || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[\s\-_.\/]/g, '');
  }

  // Libellés traduits fournis par le template Liquid
  var libelles = {};
  var modele = racine.querySelector('[data-tsi-libelles]');
  if (modele) {
    modele.content.querySelectorAll('[data-cle]').forEach(function (el) {
      libelles[el.getAttribute('data-cle')] = el.textContent.trim();
    });
  }
  // Jetons [[n]], [[imprimante]], [[critere]] : pas d'accolades, Shopify les refuse
  // dans une chaîne à l'intérieur de {{ }} (la balise se fermerait trop tôt).
  function libelle(cle, valeurs) {
    var texte = libelles[cle] || '';
    Object.keys(valeurs || {}).forEach(function (k) {
      texte = texte.split('[[' + k + ']]').join(valeurs[k]);
    });
    return texte;
  }
  function nombreAffiche(valeur) {
    return String(valeur).replace('.', libelles.separateur || ',');
  }

  var liste = racine.querySelector('[data-tsi-liste]');
  var items = Array.prototype.map.call(racine.querySelectorAll('[data-tsi-produit]'), function (el) {
    var d = el.dataset;
    var imprimantes = (d.imprimantes || '').split('|').filter(Boolean);
    return {
      el: el,
      largeur: d.largeur || '',
      mandrin: d.mandrin || '',
      adhesif: d.adhesif || '',
      longueur: parseFloat(d.longueur) || 0,
      imprimantes: imprimantes,
      cles: imprimantes.map(normaliser),
      unitaire: parseInt(d.unitaire, 10) || 0,
      metre: parseFloat(d.metre) || Infinity,
      carton: parseInt(d.carton, 10) || 0,
      tsi: d.tsi === '1',
      index: parseInt(d.index, 10) || 0,
      badge: el.querySelector('[data-tsi-badge-compatible]'),
      badgeModele: el.querySelector('[data-tsi-modele]')
    };
  });
  if (!items.length) return;

  var filtres = racine.querySelector('[data-tsi-filtres]');
  var saisie = racine.querySelector('[data-tsi-imprimante]');
  var effacer = racine.querySelector('[data-tsi-effacer]');
  var statut = racine.querySelector('[data-tsi-statut-imprimante]');
  var inconnue = racine.querySelector('[data-tsi-imprimante-inconnue]');
  var compteur = racine.querySelector('[data-tsi-compteur]');
  var puces = racine.querySelector('[data-tsi-puces]');
  var vide = racine.querySelector('[data-tsi-vide]');
  var tri = racine.querySelector('[data-tsi-tri]');
  var aideAdhesif = racine.querySelector('[data-tsi-aide-adhesif]');
  var groupeMandrin = racine.querySelector('[data-tsi-groupe-mandrin]');
  var plusCriteres = racine.querySelector('[data-tsi-plus-criteres]');
  var videGenerique = racine.querySelector('[data-tsi-vide-generique]');
  var videReinitialiser = racine.querySelector('[data-tsi-vide-reinitialiser]');
  var blocSuggestion = racine.querySelector('[data-tsi-suggestion]');
  var suggestionTitre = racine.querySelector('[data-tsi-suggestion-titre]');
  var suggestionTexte = racine.querySelector('[data-tsi-suggestion-texte]');
  var suggestionChoix = racine.querySelector('[data-tsi-suggestion-choix]');
  var apercu = racine.querySelector('[data-tsi-apercu]');
  var apercuTitre = racine.querySelector('[data-tsi-apercu-titre]');
  var apercuListe = racine.querySelector('[data-tsi-apercu-liste]');
  filtres.hidden = false;
  racine.querySelector('[data-tsi-tri-conteneur]').hidden = false;

  var etat = { imprimante: '', largeur: '', adhesif: '', mandrin: '', tri: 'reco' };

  // État initial depuis l'URL (?imprimante=&largeur=&adhesif=&mandrin=&tri=)
  var params = new URLSearchParams(window.location.search);
  etat.imprimante = (params.get('imprimante') || '').slice(0, 80);
  // Largeur et mandrin normalisés comme data-largeur / data-mandrin (« 80 », « 25.4 ») :
  // tolère les espaces (« +80 » dans l'URL), la virgule et les zéros (« 80,0 »)
  var nombreUrl = function (valeur) {
    var n = parseFloat(String(valeur || '').trim().replace(',', '.'));
    return isNaN(n) ? '' : String(n);
  };
  etat.largeur = nombreUrl(params.get('largeur'));
  etat.mandrin = nombreUrl(params.get('mandrin'));
  etat.tri = ['reco', 'unitaire', 'metre', 'carton', 'longueur'].indexOf(params.get('tri')) !== -1 ? params.get('tri') : 'reco';
  var adhesifUrl = normaliser(params.get('adhesif'));
  if (adhesifUrl) {
    items.some(function (i) {
      if (normaliser(i.adhesif) === adhesifUrl) { etat.adhesif = i.adhesif; return true; }
      return false;
    });
  }
  saisie.value = etat.imprimante;
  tri.value = etat.tri;

  function modeleCompatible(item, q) {
    if (!q) return null;
    for (var i = 0; i < item.cles.length; i++) {
      var c = item.cles[i];
      if (c.indexOf(q) !== -1 || (c.length >= 4 && q.indexOf(c) !== -1)) return item.imprimantes[i];
    }
    return null;
  }

  function correspond(item, sauf) {
    var q = normaliser(etat.imprimante);
    if (sauf !== 'imprimante' && q && !modeleCompatible(item, q)) return false;
    for (var i = 0; i < CRITERES.length; i++) {
      var c = CRITERES[i];
      if (c !== sauf && etat[c] && item[c] !== etat[c]) return false;
    }
    return true;
  }

  // Listes déroulantes : valeurs uniques présentes dans la collection, triées
  var listes = {};
  CRITERES.forEach(function (critere) {
    var select = racine.querySelector('[data-tsi-select="' + critere + '"]');
    var suffixe = select.getAttribute('data-suffixe') || '';
    var valeurs = [];
    items.forEach(function (i) { if (i[critere] && valeurs.indexOf(i[critere]) === -1) valeurs.push(i[critere]); });
    valeurs.sort(function (a, b) {
      var na = parseFloat(a), nb = parseFloat(b);
      return isNaN(na) || isNaN(nb) ? a.localeCompare(b, document.documentElement.lang) : na - nb;
    });
    var tous = document.createElement('option');
    tous.value = '';
    select.appendChild(tous);
    var options = valeurs.map(function (valeur) {
      var option = document.createElement('option');
      option.value = valeur;
      select.appendChild(option);
      return { option: option, valeur: valeur, texte: critere === 'adhesif' ? valeur : nombreAffiche(valeur) + suffixe };
    });
    select.addEventListener('change', function () {
      etat[critere] = select.value;
      rendre();
    });
    // Groupe des valeurs non compatibles avec l'imprimante saisie (rempli par rendre())
    var groupe = document.createElement('optgroup');
    groupe.label = libelle('groupe_non_compatibles');
    groupe.disabled = true;
    listes[critere] = {
      select: select,
      tous: tous,
      options: options,
      groupe: groupe,
      note: racine.querySelector('[data-tsi-incompatible="' + critere + '"]'),
      libelleTous: libelle(critere === 'largeur' ? 'toutes' : 'tous')
    };
  });

  // Valeur lisible d'un critère : « 80 mm », « 25,4 mm » ou le nom de l'adhésif
  function valeurAffichee(critere, valeur) {
    return critere === 'adhesif' ? valeur : nombreAffiche(valeur) + ' mm';
  }

  // Premier critère actif qui, retiré, redonne des bobines (imprimante et autres critères
  // conservés). Renvoie ses valeurs possibles triées par nombre de bobines décroissant.
  function chercherSuggestion() {
    var ordre = ['largeur', 'mandrin', 'adhesif'];
    for (var k = 0; k < ordre.length; k++) {
      var critere = ordre[k];
      if (!etat[critere]) continue;
      var comptes = {};
      var valeurs = [];
      var total = 0;
      items.forEach(function (i) {
        if (!i[critere] || !correspond(i, critere)) return;
        if (!comptes[i[critere]]) { comptes[i[critere]] = 0; valeurs.push(i[critere]); }
        comptes[i[critere]]++;
        total++;
      });
      if (!valeurs.length) continue;
      valeurs.sort(function (a, b) { return comptes[b] - comptes[a] || parseFloat(b) - parseFloat(a) || 0; });
      return { critere: critere, valeurs: valeurs, comptes: comptes, total: total };
    }
    return null;
  }

  function carteApercu(item) {
    var lienProduit = item.el.querySelector('.tsi-finder__nom a');
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.className = 'tsi-finder__apercu-lien';
    a.href = lienProduit ? lienProduit.href : '#';
    var image = item.el.querySelector('.tsi-finder__vignette img');
    if (image) {
      var copie = image.cloneNode(true);
      copie.removeAttribute('srcset');
      copie.src = image.currentSrc || image.src;
      a.appendChild(copie);
    }
    var nom = document.createElement('span');
    nom.className = 'tsi-finder__apercu-nom';
    nom.textContent = lienProduit ? lienProduit.textContent.trim() : '';
    a.appendChild(nom);
    var montant = item.el.querySelector('.tsi-prix-unitaire__montant');
    var unite = item.el.querySelector('.tsi-prix-unitaire__unite');
    if (montant) {
      var prix = document.createElement('span');
      prix.className = 'tsi-finder__apercu-prix';
      prix.textContent = montant.textContent.trim() + (unite ? ' ' + unite.textContent.trim() : '');
      a.appendChild(prix);
    }
    li.appendChild(a);
    return li;
  }

  // Remplit le bloc suggestion ; renvoie false s'il n'y a rien à proposer
  function rendreSuggestion(compatibles, nomImprimante) {
    var s = chercherSuggestion();
    if (!s) return false;
    var critere = s.critere;
    var valeur = etat[critere];
    var incompatible = !!compatibles && !compatibles.some(function (i) { return i[critere] === valeur; });

    suggestionTitre.textContent = incompatible
      ? libelle('suggestion_titre_' + critere, { imprimante: nomImprimante, valeur: valeurAffichee(critere, valeur) })
      : libelle('suggestion_titre_combinaison', { valeur: valeurAffichee(critere, valeur) });

    // Largeur trop grande : la largeur maximale vient des bobines compatibles avec l'imprimante
    var texte = libelle(incompatible ? 'suggestion_choix_' + critere : 'suggestion_choix_combinaison');
    if (incompatible && critere === 'largeur') {
      var max = 0;
      compatibles.forEach(function (i) { max = Math.max(max, parseFloat(i.largeur) || 0); });
      if (max && parseFloat(valeur) > max) texte = libelle('suggestion_max_largeur', { max: nombreAffiche(max) }) + ' ' + texte;
    }
    suggestionTexte.textContent = texte;

    suggestionChoix.innerHTML = '';
    s.valeurs.forEach(function (v, index) {
      var n = s.comptes[v];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tsi-btn ' + (index === 0 ? 'tsi-btn--encre' : 'tsi-btn--contour');
      var cle = (index === 0 ? 'suggestion_voir' : 'suggestion_option') + (n === 1 ? '_un' : '');
      b.textContent = libelle(cle, { valeur: valeurAffichee(critere, v), n: n });
      b.addEventListener('click', function () { etat[critere] = v; rendre(); });
      suggestionChoix.appendChild(b);
    });
    if (s.valeurs.length > 1) {
      var tous = document.createElement('button');
      tous.type = 'button';
      tous.className = 'tsi-finder__reinitialiser';
      tous.textContent = libelle('suggestion_tous_' + critere, { n: s.total });
      tous.addEventListener('click', function () { etat[critere] = ''; rendre(); });
      suggestionChoix.appendChild(tous);
    }

    // Aperçu : 3 premières bobines (tri en cours) de la valeur la plus fournie
    var premiere = s.valeurs[0];
    var selection = items.filter(function (i) { return i[critere] === premiere && correspond(i, critere); }).sort(trier).slice(0, 3);
    apercuListe.innerHTML = '';
    selection.forEach(function (i) { apercuListe.appendChild(carteApercu(i)); });
    apercuTitre.textContent = libelle('suggestion_apercu', { valeur: valeurAffichee(critere, premiere) });
    apercu.hidden = !selection.length;
    return true;
  }

  function trier(a, b) {
    // Fabricant mis en avant toujours en tête, quel que soit le tri
    var fabricant = b.tsi - a.tsi;
    if (fabricant) return fabricant;
    if (etat.tri === 'metre') {
      if (a.metre !== b.metre) return a.metre === Infinity ? 1 : b.metre === Infinity ? -1 : a.metre - b.metre;
      return a.index - b.index;
    }
    if (etat.tri === 'carton') return a.carton - b.carton || a.index - b.index;
    if (etat.tri === 'longueur') return b.longueur - a.longueur || a.index - b.index;
    return a.unitaire - b.unitaire || a.index - b.index;
  }

  function mettreAJourUrl() {
    var p = new URLSearchParams();
    if (etat.imprimante) p.set('imprimante', etat.imprimante);
    if (etat.largeur) p.set('largeur', etat.largeur);
    if (etat.adhesif) p.set('adhesif', normaliser(etat.adhesif));
    if (etat.mandrin) p.set('mandrin', etat.mandrin);
    if (etat.tri !== 'reco') p.set('tri', etat.tri);
    var chaine = p.toString();
    history.replaceState(null, '', window.location.pathname + (chaine ? '?' + chaine : ''));
  }

  function puce(texte, retirer) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tsi-finder__puce';
    b.textContent = texte + ' ×';
    b.setAttribute('aria-label', libelle('retirer', { critere: texte }));
    b.addEventListener('click', retirer);
    puces.appendChild(b);
  }

  function rendre() {
    var q = normaliser(etat.imprimante);
    // Bobines compatibles avec l'imprimante saisie (null si aucune imprimante reconnue)
    var compatibles = q ? items.filter(function (i) { return modeleCompatible(i, q); }) : [];
    if (!compatibles.length) compatibles = null;

    // Listes : compteurs (critères dépendants), options vides désactivées, valeurs non
    // compatibles avec l'imprimante regroupées en fin de liste, valeur choisie
    CRITERES.forEach(function (critere) {
      var l = listes[critere];
      var total = 0;
      items.forEach(function (i) { if (correspond(i, critere)) total++; });
      l.tous.textContent = l.libelleTous + ' (' + total + ')';
      var acceptees = {};
      if (compatibles) compatibles.forEach(function (i) { acceptees[i[critere]] = true; });
      l.groupe.innerHTML = '';
      l.options.forEach(function (o) {
        var actif = etat[critere] === o.valeur;
        if (compatibles && !acceptees[o.valeur]) {
          o.option.textContent = o.texte;
          o.option.disabled = !actif;
          l.groupe.appendChild(o.option);
          return;
        }
        var n = 0;
        items.forEach(function (i) { if (i[critere] === o.valeur && correspond(i, critere)) n++; });
        o.option.textContent = o.texte + ' (' + n + ')';
        o.option.disabled = n === 0 && !actif;
        l.select.appendChild(o.option);
      });
      if (l.groupe.children.length) l.select.appendChild(l.groupe);
      else if (l.groupe.parentNode) l.groupe.parentNode.removeChild(l.groupe);
      l.select.value = etat[critere];
      var nonCompatible = !!(etat[critere] && compatibles && !acceptees[etat[critere]]);
      l.select.classList.toggle('tsi-finder__select--choisi', !!etat[critere] && !nonCompatible);
      l.select.classList.toggle('tsi-finder__select--incompatible', nonCompatible);
      if (l.note) l.note.hidden = !nonCompatible;
    });
    var aide = etat.adhesif ? libelles['adhesif_' + normaliser(etat.adhesif)] : '';
    aideAdhesif.textContent = aide || '';
    aideAdhesif.hidden = !aide;

    // Résultats
    var visibles = items.filter(function (i) { return correspond(i); }).sort(trier);
    items.forEach(function (i) { i.el.hidden = true; });
    visibles.forEach(function (i) {
      i.el.hidden = false;
      liste.appendChild(i.el);
      var m = modeleCompatible(i, q);
      i.badge.hidden = !m;
      if (m) i.badgeModele.textContent = m;
    });

    // Statut imprimante
    var nbImprimante = q ? items.filter(function (i) { return modeleCompatible(i, q); }).length : 0;
    effacer.hidden = !etat.imprimante;
    statut.textContent = q && nbImprimante ? libelle('statut_imprimante', { n: nbImprimante }) : '';
    inconnue.hidden = !(q.length >= 3 && nbImprimante === 0);

    // Compteur et état vide
    var n = visibles.length;
    var texte = n === 0 ? libelle('compteur_zero') : n === 1 ? libelle('compteur_un') : libelle('compteur_plusieurs', { n: n });
    if (n && etat.imprimante && nbImprimante) texte += ' ' + libelle('compteur_avec', { imprimante: etat.imprimante });
    compteur.textContent = texte;
    vide.hidden = n !== 0;
    var nomImprimante = compatibles ? modeleCompatible(compatibles[0], q) : '';
    var avecSuggestion = n === 0 && rendreSuggestion(compatibles, nomImprimante);
    blocSuggestion.hidden = !avecSuggestion;
    videGenerique.hidden = avecSuggestion;
    videReinitialiser.hidden = avecSuggestion;

    // Puces des critères actifs
    puces.innerHTML = '';
    if (etat.imprimante) puce(etat.imprimante, function () { etat.imprimante = ''; saisie.value = ''; rendre(); });
    if (etat.largeur) puce(nombreAffiche(etat.largeur) + ' mm', function () { etat.largeur = ''; rendre(); });
    if (etat.adhesif) puce(etat.adhesif, function () { etat.adhesif = ''; rendre(); });
    if (etat.mandrin) puce(libelle('mandrin') + ' ' + nombreAffiche(etat.mandrin) + ' mm', function () { etat.mandrin = ''; rendre(); });
    if (etat.imprimante || etat.largeur || etat.adhesif || etat.mandrin) {
      var reinit = document.createElement('button');
      reinit.type = 'button';
      reinit.className = 'tsi-finder__reinitialiser';
      reinit.textContent = libelle('reinitialiser');
      reinit.addEventListener('click', toutEffacer);
      puces.appendChild(reinit);
    }

    mettreAJourUrl();
    if (interactif) garderResultatsVisibles();
  }

  // Quand un filtre réduit la liste, la page raccourcit et le haut des résultats peut
  // passer au-dessus de l'écran (on se retrouve « ancré en bas », sur une zone vide).
  // On remonte alors au début des résultats, juste sous l'en-tête figé.
  var resultats = racine.querySelector('.tsi-finder__resultats');
  var interactif = false;
  function garderResultatsVisibles() {
    if (!resultats) return;
    var styles = getComputedStyle(document.documentElement);
    var entete = (parseFloat(styles.getPropertyValue('--header-height')) || 0) + (parseFloat(styles.getPropertyValue('--tsi-annonce-hauteur')) || 0);
    var haut = resultats.getBoundingClientRect().top;
    if (haut < entete) {
      var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: window.scrollY + haut - entete - 16, behavior: reduit ? 'auto' : 'smooth' });
    }
  }
  if (resultats) resultats.style.overflowAnchor = 'none';

  // Mobile : le mandrin, replié par défaut, s'affiche sur demande
  function deplierMandrin(ouvert) {
    groupeMandrin.classList.toggle('tsi-finder__groupe--deplie', ouvert);
    plusCriteres.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  }
  plusCriteres.addEventListener('click', function () {
    deplierMandrin(plusCriteres.getAttribute('aria-expanded') !== 'true');
  });

  var minuterie;
  saisie.addEventListener('input', function () {
    clearTimeout(minuterie);
    minuterie = setTimeout(function () { etat.imprimante = saisie.value.trim(); rendre(); }, 150);
  });
  effacer.addEventListener('click', function () { saisie.value = ''; etat.imprimante = ''; rendre(); saisie.focus(); });
  tri.addEventListener('change', function () { etat.tri = tri.value; rendre(); });
  filtres.addEventListener('submit', function (e) { e.preventDefault(); });
  function toutEffacer(e) {
    if (e) e.preventDefault();
    etat.imprimante = etat.largeur = etat.adhesif = etat.mandrin = '';
    saisie.value = '';
    rendre();
  }
  racine.querySelectorAll('[data-tsi-reinitialiser]').forEach(function (b) {
    b.addEventListener('click', toutEffacer);
  });

  // Déplie le mandrin (mobile) s'il vient de l'URL
  if (etat.mandrin) deplierMandrin(true);

  rendre();
  interactif = true;

  // Ajout au panier sans rechargement (même mécanique que product-form.js de Dawn).
  // Sans tiroir panier ou en cas d'erreur, le formulaire est envoyé normalement.
  var messageAjout = racine.querySelector('[data-tsi-message-ajout]');
  racine.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-tsi-ajout]');
    var tiroir = document.querySelector('cart-drawer');
    if (!form || !tiroir || !window.fetch || !window.routes) return;
    e.preventDefault();
    var bouton = form.querySelector('[type="submit"]');
    bouton.setAttribute('aria-disabled', 'true');
    bouton.classList.add('loading');
    var donnees = new FormData(form);
    donnees.append('sections', tiroir.getSectionsToRender().map(function (s) { return s.id; }));
    donnees.append('sections_url', window.location.pathname);
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: donnees
    })
      .then(function (r) { return r.json(); })
      .then(function (reponse) {
        if (reponse.status) throw new Error(reponse.description || reponse.message);
        if (tiroir.classList.contains('is-empty')) tiroir.classList.remove('is-empty');
        tiroir.renderContents(reponse);
        messageAjout.textContent = libelle('ajoute');
      })
      .catch(function () {
        messageAjout.textContent = libelle('erreur');
        form.submit();
      })
      .finally(function () {
        bouton.removeAttribute('aria-disabled');
        bouton.classList.remove('loading');
      });
  });
})();
